import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const TopBtnOld = styled(Button)`
  width: ${mixin.pxToVw('40')};
  height: ${mixin.pxToVw('40')};
  position: absolute;
  bottom: ${mixin.pxToVw('66')};
  right: ${mixin.pxToVw('20')};
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s, bottom 0.3s;

  svg {
    width: 100%;
    height: 100%;
  }

  &.active {
    opacity: 1;
    visibility: visible;
  }

  @media ${({ theme }) => theme.media.sm} {
    .btn-top {
      width: 40px;
      height: 40px;
      bottom: 66px;
      right: 20px;
    }
  }
`;
